<script>
export default {
  computed: {
    isBusinessUser() {
      return true
    },
  },
}
</script>
